var _excluded = ["onMount", "width"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import Modal from "../modals/modal-deprecated";
import ModalFormBase from "./modal-form-base";

var ModalForm = function ModalForm(_ref) {
  var onMount = _ref.onMount,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Modal, {
    width: width,
    onUnmount: props.onUnmount,
    onMount: onMount,
    onClose: props.onClose,
    closeOnEscape: true,
    closeOnOutsideClick: true
  }, /*#__PURE__*/React.createElement(ModalFormBase, _extends({
    onClose: props.onClose
  }, props)));
};

ModalForm.defaultProps = {
  onUnmount: function onUnmount() {},
  onMount: function onMount() {},
  onClose: function onClose() {},
  width: 500
};
ModalForm.propTypes = {
  onUnmount: PropTypes.func,
  onMount: PropTypes.func,
  onClose: PropTypes.func,
  width: PropTypes.number
};
ModalForm.displayName = "ModalForm";
export default ModalForm;